var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "20px" }, attrs: { id: "tags" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.cols,
          rows: _vm.tags.data,
          options: _vm.tableOptions,
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-end align-items-center",
                  },
                  [
                    _c(
                      "supsis-button",
                      {
                        staticClass: "add-tag-button",
                        attrs: { primary: "" },
                        on: { click: _vm.showModalView },
                      },
                      [
                        _c("md-icon", { staticStyle: { color: "white" } }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.addTag")) +
                            "\n                "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "tags-form",
                title: _vm.editMode
                  ? _vm.$t("message.updateTag")
                  : _vm.$t("message.addTag"),
                "show-footer": false,
                rowKey: "_id",
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "a-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.duplicateControl.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "a-col",
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: _vm.$t("message.tagName") } },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: _vm.$t("message.tagName"),
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: _vm.$t("message.tagDescription"),
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: _vm.$t("message.tagDescription"),
                                },
                                model: {
                                  value: _vm.form.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "description", $$v)
                                  },
                                  expression: "form.description",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-form-item",
                            { attrs: { label: _vm.$t("message.tagColor") } },
                            [
                              _c("a-input", {
                                attrs: { type: "color" },
                                model: {
                                  value: _vm.form.color,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "color", $$v)
                                  },
                                  expression: "form.color",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { id: "buttons" } },
                        [
                          _c("a-button", { on: { click: _vm.hideModal } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.cancel")) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "btn-primary",
                              attrs: {
                                disabled: _vm.loading,
                                type: "submit",
                                variant: "primary",
                              },
                              on: { click: _vm.duplicateControl },
                            },
                            [
                              !_vm.loading
                                ? [
                                    !_vm.editMode
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("message.save")) +
                                              "\n                            "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("message.update")) +
                                              "\n                            "
                                          ),
                                        ]),
                                  ]
                                : [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "spinner", spin: "" },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }